import { render } from "./BenchmarkViewWilandSection.vue?vue&type=template&id=3b5ba81f"
import script from "./BenchmarkViewWilandSection.vue?vue&type=script&lang=js"
export * from "./BenchmarkViewWilandSection.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/components/insights/BenchmarkViewWilandSection.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "3b5ba81f"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('3b5ba81f', __exports__)) {
    api.reload('3b5ba81f', __exports__)
  }
  
  module.hot.accept("./BenchmarkViewWilandSection.vue?vue&type=template&id=3b5ba81f", () => {
    api.rerender('3b5ba81f', render)
  })

}


export default __exports__